const DEVICE_SIZE = {
    MOBILE: 'xs',
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg',
    EXTRA_LARGE: 'xl',
};
export default DEVICE_SIZE;

export type ScreenSizeType = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
